import styled from 'styled-components';

export const FooterWrapper = styled.div`
    position: fixed;
    top: auto;
    bottom: 0;
    width: 100%;
    height: 115px;
    display: flex;
    flex-direction: column;
`
export const FooterContext = styled.div`
    background-color: var(--color-black);
    color: var(--color-white);
    display: flex;
    flex-grow: 1;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;

    p {
        margin-left: 20px;
        margin-right: 20px;
    }

    a {
        color: var(--color-white);
    }

    a:hover {
        color: var(--color-yellow);
    }
`